import { Box, MenuItem, styled, Typography } from '@mui/material';
import { pxToRem } from '@themes';
var StyledContentContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: "".concat(pxToRem(30), " ").concat(pxToRem(20), " ").concat(pxToRem(0))
  };
});
var StyledTypography = styled(Typography)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    color: theme.colors.waterloo
  };
});
var StyledIconBox = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    padding: "".concat(pxToRem(6)),
    borderRadius: pxToRem(12),
    boxShadow: '0px 1px 5px rgba(187, 190, 199, 0.4)'
  };
});
var StyledMenuItem = styled(MenuItem)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    padding: "".concat(pxToRem(16), " ").concat(pxToRem(12))
  };
});
export { StyledContentContainer, StyledIconBox, StyledMenuItem, StyledTypography };